export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  experimentsLoadingCover: true,
  features: {
    /**
     * @description Enables new category page design
     * @author Pawel Galazka
     * @expires when category pages experiment is over for all markets
     */
    categoryRedesign: true
  },
  show_category_in_selected_filters: true
}
